import React from "react";
import PropTypes from "prop-types";
import cx from "clsx";
import { useClinicsQuery } from "../../../../../api/queries/useClinicsQuery";
import { Select } from "../../../../../shared/Select/Select";
import { withGlobalSettings } from "../../../../../hocs/withGlobalSettings.js";
import classes from "./PosClinicFilter.module.scss";

function PosClinicFilterComponent({
  isClinicConnection,
  value,
  onChange,
  className,
  globalSettings,
}) {
  const isEnabled = Boolean(globalSettings?.feature_flag?.pos_clinic_filter);
  const showFilter = isClinicConnection && isEnabled;
  const { data, isLoading } = useClinicsQuery({
    enabled: showFilter,
  });

  if (!showFilter) {
    return null;
  }

  const options = (data || []).map((clinic) => ({
    label: clinic.name,
    value: clinic.id,
  }));

  return (
    <div className={cx(classes.root, className)}>
      <Select
        size="small"
        isSearchable
        isClearable
        isFixed
        placeholder="All Clinics"
        options={options}
        value={options.find((option) => option.value === value) || null}
        onChange={(option) => onChange(option ? option.value : "")}
        isLoading={isLoading}
      />
    </div>
  );
}

PosClinicFilterComponent.propTypes = {
  isClinicConnection: PropTypes.bool.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  globalSettings: PropTypes.object,
};

PosClinicFilterComponent.defaultProps = {
  value: "",
  className: "",
};

export const PosClinicFilter = withGlobalSettings(PosClinicFilterComponent);
